export const sortByOptions = [
  { value: 1, label: 'Item Code' },
  { value: 2, label: 'Item Description' },
];

export const groupByOptions = [
  { value: 1, label: 'Storage Location' },
  { value: 2, label: 'Truck Route' },
  { value: 3, label: 'Ordering Site' },
];



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousepicklist/helper/index.js